import React from 'react';

const DocumentSparkleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="10" y="6" width="28" height="36" rx="4" fill="#EDE9FE" stroke="#7C3AED" strokeWidth="1.5" />
    <path d="M16 16h16M16 22h16M16 28h10" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M36 10l1.2 2.4 2.4 1.2-2.4 1.2L36 17l-1.2-2.4-2.4-1.2 2.4-1.2L36 10z"
      fill="#7C3AED"
    />
    <path
      d="M38 28l.8 1.6 1.6.8-1.6.8L38 33l-.8-1.6-1.6-.8 1.6-.8L38 28z"
      fill="#A78BFA"
    />
  </svg>
);

const DocumentErrorIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="10" y="6" width="28" height="36" rx="4" fill="#FEE2E2" stroke="#DC2626" strokeWidth="1.5" />
    <path d="M16 16h16M16 22h16M16 28h10" stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="36" cy="14" r="8" fill="#DC2626" />
    <path d="M33.5 11.5l5 5M38.5 11.5l-5 5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const SparkleIcon = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    />
  </svg>
);

export const PendingGenerationEmptyState = ({
  t,
  onConfigureGeneration,
  isCreditsExhausted,
  onCreditsLimitClick,
  hasAxeRedaction = true,
}) => {
  const handleConfigure = () => {
    if (isCreditsExhausted) {
      onCreditsLimitClick?.();
      return;
    }
    onConfigureGeneration?.();
  };

  const isGenerationError = !hasAxeRedaction;

  return (
    <>
      <style>{`
        .pending-generation-empty {
          display: flex;
          justify-content: center;
          padding: 32px 20px 48px;
        }
        .pending-generation-empty__card {
          width: 100%;
          max-width: 560px;
          background: #fff;
          border: 1px solid #E9E9E9;
          border-radius: 16px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
          padding: 40px 32px 32px;
          text-align: center;
        }
        .pending-generation-empty__icon {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
        }
        .pending-generation-empty__title {
          font-size: 18px;
          font-weight: 600;
          color: #111827;
          margin: 0 0 12px;
        }
        .pending-generation-empty__desc {
          font-size: 14px;
          line-height: 1.6;
          color: #6B7280;
          margin: 0 0 28px;
        }
        .pending-generation-empty__btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 24px;
          background: #6458F1;
          color: #fff;
          border: none;
          border-radius: 999px;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }
        .pending-generation-empty__btn:hover {
          background: #5348d9;
        }
        .pending-generation-empty__btn-icon {
          width: 16px;
          height: 16px;
        }
        .pending-generation-empty__footer {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          margin-top: 24px;
          font-size: 12px;
          color: #9CA3AF;
        }
      `}</style>
      <div className="pending-generation-empty">
        <div className="pending-generation-empty__card">
          <div className="pending-generation-empty__icon">
            {isGenerationError ? <DocumentErrorIcon /> : <DocumentSparkleIcon />}
          </div>
          <h2 className="pending-generation-empty__title">
            {isGenerationError
              ? t("Une erreur s'est produite lors de la génération")
              : t("Le contenu n'a pas encore été généré")}
          </h2>
          <p className="pending-generation-empty__desc">
            {isGenerationError
              ? t(
                  "La génération du contenu a échoué. Vous pouvez relancer la configuration pour réessayer."
                )
              : t(
                  "Votre brief est prêt, mais aucun texte n'a encore été rédigé à partir de celui-ci. Configurez votre génération à l'aide du formulaire pour lancer la rédaction IA."
                )}
          </p>
          <button
            type="button"
            className="pending-generation-empty__btn"
            onClick={handleConfigure}
          >
            <img
              src="/Images/set-icon.png"
              alt=""
              className="pending-generation-empty__btn-icon"
              aria-hidden="true"
            />
            {isGenerationError
              ? t('Relancer la génération')
              : t('Configurer la génération')}
          </button>
          {!isGenerationError && (
            <div className="pending-generation-empty__footer">
              <SparkleIcon />
              <span>{t('Cette génération utilisera vos crédits IA disponibles')}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PendingGenerationEmptyState;
